import { Toolbar, Stack, Button, AppBar, Box } from "@mui/material";
import Logo from "../../../assets/logo.png";
import { handleNavClick } from "../../../utils/Functions";

const Navbar = () => {

  return (
    <>
      <AppBar sx={{ backgroundColor: "#0000" }}>
        <Toolbar
          sx={{
            backgroundColor: "#111111",
            p: 1,
            display: "flex",
            justifyContent: {
              xs: "center",
              sm: "space-between",
            },
          }}
        >
          <Box
            component="img"
            sx={{
              width: "100%",
              maxWidth: "60px",
              height: "auto",
              display: {
                xs: "none",
                sm: "block",
              },
            }}
            alt="Logo"
            src={Logo}
          />
          <Stack direction="row">
            <Button
              onClick={(e) => handleNavClick("skills-section", e)}
            >
              Skills
            </Button>
            <Button
              onClick={(e) => handleNavClick("projects-section", e)}
            >
              Projects
            </Button>
            <Button
              onClick={(e) => handleNavClick("contact-section", e)}
            >
              Contact
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;